export default {
      id: "partner-DCM-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#partner-DCM",
      toString: function () {
        return this.url;
      }
    }